import { render, staticRenderFns } from "./damagesExtraDetails.pug?vue&type=template&id=eb3ed94e&lang=pug&"
import script from "./damagesExtraDetails.js?vue&type=script&lang=js&"
export * from "./damagesExtraDetails.js?vue&type=script&lang=js&"
import style0 from "./damagesExtraDetails.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb3ed94e')) {
      api.createRecord('eb3ed94e', component.options)
    } else {
      api.reload('eb3ed94e', component.options)
    }
    module.hot.accept("./damagesExtraDetails.pug?vue&type=template&id=eb3ed94e&lang=pug&", function () {
      api.rerender('eb3ed94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagesExtraDetails/index.vue"
export default component.exports